import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/(home)/_components/Messengers/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/youTubeShorts.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/glob.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/trendex.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/BottomMenu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterPoolsLink"] */ "/app/src/components/global/Footer/FooterPoolsLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/global/GreyListedCountryPopup/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollRestoration"] */ "/app/src/components/global/ScrollRestoration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/app/src/components/header/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/AuditChecked/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/Community/CommunityItem.tsx");
